// TIP: To use a local image, import it at the top:
// import myLocalImage from '../assets/images/my-service.jpg';
// Then replace the URL with the variable: image: myLocalImage

import portfolio1 from '../assets/images/Portfolio1.jpg';
import portfolio2 from '../assets/images/Portfolio2.jpg';
import portfolio3 from '../assets/images/Portfolio3.jpg';
import portfolio4 from '../assets/images/Portfolio4.jpg';
import portfolio5 from '../assets/images/Portfolio5.jpg';
import portfolio6 from '../assets/images/Portfolio6.jpg';
import portfolio7 from '../assets/images/Portfolio7.jpg';
import portfolio8 from '../assets/images/Portfolio8.jpg';
import portfolio9 from '../assets/images/Portfolio9.jpg';
import portfolio10 from '../assets/images/Portfolio10.jpg';
import portfolio11 from '../assets/images/Portfolio11.jpg';
import portfolio12 from '../assets/images/Portfolio12.jpg';
import portfolio13 from '../assets/images/Portfolio13.jpg';
import portfolio14 from '../assets/images/Portfolio14.jpg';
import portfolio15 from '../assets/images/Portfolio15.jpg';
import portfolio16 from '../assets/images/Portfolio16.jpg';
import portfolio17 from '../assets/images/Portfolio17.jpg';
import portfolio18 from '../assets/images/Portfolio18.jpg';
import portfolio19 from '../assets/images/Portfolio19.jpg';
import portfolio20 from '../assets/images/Portfolio20.jpg';
import portfolio21 from '../assets/images/Portfolio21.jpg';
import portfolio22 from '../assets/images/Portfolio22.jpg';
import portfolio23 from '../assets/images/Portfolio23.jpg';
import portfolio24 from '../assets/images/Portfolio24.jpg';
import portfolio25 from '../assets/images/Portfolio25.jpg';
import portfolio26 from '../assets/images/Portfolio26.jpg';
import portfolio27 from '../assets/images/Portfolio27.jpg';
import portfolio28 from '../assets/images/Portfolio28.jpg';
import portfolio29 from '../assets/images/Portfolio29.jpg';
import portfolio30 from '../assets/images/Portfolio30.jpg';
import portfolio31 from '../assets/images/Portfolio31.jpg';
import portfolio32 from '../assets/images/Portfolio32.jpg';
import portfolio33 from '../assets/images/Portfolio33.jpg';
import portfolio34 from '../assets/images/Portfolio34.jpg';
import portfolio35 from '../assets/images/Portfolio35.jpg';
import portfolio36 from '../assets/images/Portfolio36.jpg';
import portfolio37 from '../assets/images/Portfolio37.jpg';
import portfolio38 from '../assets/images/Portfolio38.jpg';
import SkinTreatment from '../assets/images/SkinTreatment1.jpg';

export const SERVICES = [
  {
    id: 'acrylic-full-set',
    title: {
      en: 'Acrylic Full Set',
      fr: 'Pose complète en acrylique',
    },
    description: {
      en: 'Premium acrylic extensions tailored to your desired length and shape. Includes cuticle care and solid gel color.',
      fr: 'Extensions acryliques haut de gamme adaptées à la longueur et à la forme souhaitées. Inclut le soin des cuticules et une couleur gel unie.',
    },
    price: {
      en: 'From $85',
      fr: 'À partir de 85 $',
    },
    image: portfolio21
  },
  {
    id: 'gel-manicure',
    title: {
      en: 'Structured Gel Manicure',
      fr: 'Manucure gel structurée',
    },
    description: {
      en: 'A durable, hard gel overlay on natural nails to promote growth and strength. Perfect for everyday elegance.',
      fr: 'Une couche de gel dur durable sur les ongles naturels pour favoriser la croissance et la solidité. Parfaite pour une élégance au quotidien.',
    },
    price: {
      en: 'From $65',
      fr: 'À partir de 65 $',
    },
    image: portfolio29
  },
  {
    id: 'custom-nail-art',
    title: {
      en: 'Custom Nail Art',
      fr: 'Nail art personnalisé',
    },
    description: {
      en: 'Intricate hand-painted designs, 3D art, encapsulated glitters, or modern French tips tailored to your style.',
      fr: 'Designs peints à la main, art 3D, paillettes encapsulées ou french moderne adaptés à votre style.',
    },
    price: {
      en: 'Add-on $15+',
      fr: 'Supplément 15 $+',
    },
    image: portfolio11
  },
  {
    id: 'skin-treatments',
    title: {
      en: 'Skin & Facial Treatments',
      fr: 'Soins de la peau et du visage',
    },
    description: {
      en: 'Rejuvenating microneedling and custom facials to give you that flawless, glowing canvas.',
      fr: 'Microneedling revitalisant et soins du visage personnalisés pour révéler une peau lumineuse et impeccable.',
    },
    price: {
      en: 'From $120',
      fr: 'À partir de 120 $',
    },
    image: SkinTreatment
  }
];

export const COURSES = [
  {
    id: 'beginner-acrylic',
    title: {
      en: 'Beginner Acrylic Course',
      fr: 'Formation acrylique débutante',
    },
    level: {
      en: 'Beginner',
      fr: 'Débutant',
    },
    duration: {
      en: '2 Days',
      fr: '2 jours',
    },
    description: {
      en: 'Start your career as a nail artist in Montreal. Learn the fundamentals of acrylic application, prep, and basic shaping.',
      fr: 'Lancez votre carrière comme prothésiste ongulaire à Montréal. Apprenez les bases de l\'application acrylique, de la préparation et des formes essentielles.',
    },
    image: portfolio21,
    learnings: {
      en: [
        'Anatomy of the nail and proper sanitation',
        'Flawless cuticle prep for retention',
        'Bead pickup and liquid-to-powder ratio',
        'Basic shaping (Square, Coffin, Almond)',
        'Client consultation basics'
      ],
      fr: [
        'Anatomie de l\'ongle et hygiène professionnelle',
        'Préparation parfaite des cuticules pour une meilleure tenue',
        'Prise de bille et ratio liquide-poudre',
        'Formes de base (carré, coffin, amande)',
        'Bases de la consultation cliente'
      ],
    },
    whoIsItFor: {
      en: 'Absolute beginners with no prior experience looking to start a lucrative career in the beauty industry.',
      fr: 'Débutantes complètes sans expérience préalable souhaitant démarrer une carrière rentable dans l\'industrie de la beauté.',
    }
  },
  {
    id: 'advanced-nail-art',
    title: {
      en: 'Advanced Nail Art Masterclass',
      fr: 'Masterclass de nail art avancé',
    },
    level: {
      en: 'Advanced',
      fr: 'Avancé',
    },
    duration: {
      en: '1 Day',
      fr: '1 jour',
    },
    description: {
      en: 'Elevate your portfolio with trending designs. Master line work, 3D elements, and advanced character art.',
      fr: 'Sublimez votre portfolio avec des designs tendance. Maîtrisez le travail de ligne, les éléments 3D et les créations artistiques avancées.',
    },
    image: portfolio23,
    learnings: {
      en: [
        'Fine line work and blending techniques',
        '3D acrylic sculpting (flowers, bows)',
        'Encapsulation and ombré mastery',
        'Working with foils, chromes, and gems',
        'Photography tips for Instagram'
      ],
      fr: [
        'Techniques de lignes fines et de dégradés',
        'Sculpture acrylique 3D (fleurs, boucles)',
        'Maîtrise de l\'encapsulation et de l\'ombré',
        'Utilisation de foils, chromes et pierres',
        'Conseils photo pour Instagram'
      ],
    },
    whoIsItFor: {
      en: 'Current nail technicians looking to upskill and offer premium, high-ticket nail art services.',
      fr: 'Techniciennes ongulaires en activité qui veulent monter en gamme et proposer des services de nail art premium.',
    }
  },
  {
    id: 'private-mentorship',
    title: {
      en: 'Private 1-on-1 Training',
      fr: 'Formation privée individuelle',
    },
    level: {
      en: 'All Levels',
      fr: 'Tous niveaux',
    },
    duration: {
      en: 'Custom',
      fr: 'Sur mesure',
    },
    description: {
      en: 'Tailored specifically to your needs. We focus on your weak points, whether it\'s shaping, speed, or business growth.',
      fr: 'Un accompagnement entièrement adapté à vos besoins. Nous travaillons sur vos points faibles, qu\'il s\'agisse des formes, de la rapidité ou du développement de votre activité.',
    },
    image: portfolio34,
    learnings: {
      en: [
        'Customized curriculum based on your requests',
        'Speed improvement techniques',
        'Business and social media strategy',
        'Troubleshooting retention issues'
      ],
      fr: [
        'Programme personnalisé selon vos besoins',
        'Techniques pour gagner en rapidité',
        'Stratégie business et réseaux sociaux',
        'Résolution des problèmes de tenue'
      ],
    },
    whoIsItFor: {
      en: 'Anyone wanting dedicated, undivided attention to rapidly improve specific skills.',
      fr: 'Toute personne souhaitant bénéficier d\'une attention exclusive pour progresser rapidement sur des compétences précises.',
    }
  }
];

export const PORTFOLIO_IMAGES = [
  portfolio1,
  portfolio2,
  portfolio3,
  portfolio4,
  portfolio5,
  portfolio6,
  portfolio7,
  portfolio8,
  portfolio9,
  portfolio10,
  portfolio11,
  portfolio12,
  portfolio13,
  portfolio14,
  portfolio15,
  portfolio16,
  portfolio17,
  portfolio18,
  portfolio19,
  portfolio20,
  portfolio21,
  portfolio22,
  portfolio23,
  portfolio24,
  portfolio25,
  portfolio26,
  portfolio27,
  portfolio28,
  portfolio29,
  portfolio30,
  portfolio31,
  portfolio32,
  portfolio33,
  portfolio34,
  portfolio35,
  portfolio36,
  portfolio37,
  portfolio38
];
